import type { Messages } from '../catalogue.en'

/**
 * The Control Center's Connected modules section. Composed into the public
 * catalogue by `catalogue.he.ts`; nothing imports this module directly.
 */
export const controlCenterModules: Partial<Messages> = {
  "clinicModules.title": "מודולי המרפאה",
  'clinicModules.subtitle':
    'מודולים משובצים הרשומים בהתקנה זו, והאם כל אחד מהם פעיל, כבוי או מוסתר במרפאה זו.',
  'clinicModules.loading': 'טוען מודולים מחוברים',
  'clinicModules.loadFailed': 'לא ניתן לטעון את קטלוג המודולים.',
  'clinicModules.loadForbidden': 'לחשבון זה אין הרשאה לצפות בקטלוג המודולים.',
  'clinicModules.forbidden': 'אין לך הרשאה לצפות בקטלוג המודולים של המרפאה',
  'clinicModules.listLabel': 'מודולים רשומים',
  'clinicModules.empty': 'אין מודולים זמינים',
  'clinicModules.emptyDetail':
    'אין מודולים זמינים לארגון זה.',
  'clinicModules.readOnly': 'ניתן לראות את מצב כל מודול אך לא לשנותו.',
  'clinicModules.readOnlyItem': 'השרת אינו מאפשר לחשבון זה לשנות מודול זה.',
  'clinicModules.column.module': 'מודול',
  'clinicModules.column.controls': 'זמינות',
  'clinicModules.backToModules': 'חזרה למודולים',
  'clinicModules.notFoundTitle': 'המודול לא נמצא',
  'clinicModules.notFound': 'מודול זה אינו זמין לארגון זה.',

  'clinicModules.views.label': 'מקטעי {name}',
  'clinicModules.views.title': 'דף שער',
  'clinicModules.views.titleDescription': 'זהות, מצב וגבולות המודול',
  'clinicModules.views.settings': 'הגדרות',
  'clinicModules.views.settingsDescription': 'זמינות ותצורת האינטגרציה',
  'clinicModules.views.debug': 'ניפוי שגיאות',
  'clinicModules.views.debugDescription': 'בדיקות ממשק מוכנות',
  'clinicModules.titleSheet.subtitle': 'מידע על המודול הרשום',
  'clinicModules.titleSheet.identity': 'זהות המודול',
  'clinicModules.titleSheet.lifecycle': 'מחזור חיים',
  'clinicModules.titleSheet.effect': 'השפעה',
  'clinicModules.titleSheet.boundaries': 'תלויות והשפעות יוצאות',
  'clinicModules.settings.title': 'הגדרות {name}',
  'clinicModules.settings.subtitle': 'זמינות המודול ותצורת האינטגרציה לכל המרפאה.',
  'clinicModules.settings.lifecycle': 'זמינות',
  'clinicModules.debug.unavailableTitle': 'ניפוי השגיאות אינו זמין',
  'clinicModules.debug.unavailable': 'הבנייה או החשבון אינם מציעים פעולות ניפוי שגיאות למודול זה.',

  'clinicModules.code': 'קוד מודול',
  'clinicModules.version': 'גרסה',
  'clinicModules.build': 'בנייה',
  'clinicModules.dependsOn': 'משתמש בשירותי ליבה',
  'clinicModules.dependsOnNone': 'לא הוצהרו',
  'clinicModules.egress': 'פעולות יוצאות',
  'clinicModules.egressNone': 'לא הוצהרו',
  'clinicModules.egress.ai': 'בינה מלאכותית',
  'clinicModules.egress.communications': 'תקשורת',
  'clinicModules.egress.patient_message': 'הודעות למטופלים',
  'clinicModules.egress.outbound_http': 'קריאות HTTP יוצאות',
  'clinicModules.egress.notification': 'התראות',
  'clinicModules.egress.background_dispatch': 'משימות רקע',
  'clinicModules.lastChange': 'שינוי אחרון',
  'clinicModules.lastChangeNever': 'מעולם לא שונה במרפאה זו',
  'clinicModules.lastChangeBy.account': '{when}, על ידי חשבון',
  'clinicModules.lastChangeBy.integration': '{when}, על ידי אינטגרציה',
  'clinicModules.lastChangeBy.unrecognized': '{when}',
  'clinicModules.changedWhen': 'מועד השינוי',

  'clinicModules.status': 'מצב',
  'clinicModules.status.enabled': 'פעיל',
  'clinicModules.status.disabled': 'כבוי',
  'clinicModules.status.hidden': 'מוסתר',
  'clinicModules.statusDetail.enabled':
    'פעיל במלואו וגלוי. בקשות נכנסות, פקודות, עבודות רקע וקריאות יוצאות שלו מתבצעות.',
  'clinicModules.statusDetail.disabled':
    'גלוי אך מושבת. נתוני המודול השמורים נשארים קריאים; שום בקשה נכנסת, פקודה, משימת רקע או קריאה יוצאת חדשה אינה מתבצעת.',
  'clinicModules.statusDetail.hidden':
    'מושבת והוסר מכל משטח רגיל. רק קטלוג זה עדיין מציג אותו. נתוני המודול השמורים נשמרים.',

  'clinicModules.health': 'תצורה',
  'clinicModules.health.ready': 'מוכן',
  'clinicModules.health.configuration_required': 'נדרשת תצורה',
  'clinicModules.health.unavailable': 'לא ניתן לבדוק',
  'clinicModules.health.unknown': 'לא דווח',
  'clinicModules.health.unrecognized': 'סטטוס לא מזוהה',
  'clinicModules.healthDetail.ready': 'התצורה המקומית מלאה.',
  'clinicModules.healthDetail.configuration_required':
    'יש להשלים את ההגדרות הנדרשות לפעולה המבוקשת. הפעלת המודול אינה ממלאת את ההגדרות שלו.',
  'clinicModules.healthDetail.unavailable':
    'לא ניתן היה לקבוע את מצב התצורה המקומית. לא נוצר קשר עם שום גורם מחוץ להתקנה זו כדי לברר.',
  'clinicModules.healthDetail.unknown': 'המודול אינו מדווח על מצב תצורה.',
  'clinicModules.healthDetail.unrecognized':
    'השרת דיווח על מצב תצורה שגרסה זו של סביבת העבודה אינה מכירה. המצב המוצג הוא עדיין זה של השרת.',
  'clinicModules.healthIssues': 'בעיות שדווחו',

  'clinicModules.switchEnabled': 'פעיל',
  'clinicModules.switchHidden': 'מוסתר',
  'clinicModules.switchOn': 'דולק',
  'clinicModules.switchOff': 'כבוי',
  'clinicModules.switchEnabledOn': 'מופעל: כן',
  'clinicModules.switchEnabledOff': 'מופעל: לא',
  'clinicModules.switchHiddenOn': 'מוסתר: כן',
  'clinicModules.switchHiddenOff': 'מוסתר: לא',
  'clinicModules.action.enable': 'הפעלה',
  'clinicModules.action.disable': 'כיבוי',
  'clinicModules.action.hide': 'הסתרה',
  'clinicModules.action.unhide': 'הצגה מחדש',
  'clinicModules.switchEnabledHint':
    'דולק: המודול פועל. כבוי: הנתונים השמורים נשארים קריאים וכל פעולה חדשה נעצרת.',
  'clinicModules.switchHiddenHint':
    'דולק: גם מכבה את המודול ומסיר אותו מכל משטח רגיל. כבוי: המודול מוצג שוב אך נשאר כבוי.',
  'clinicModules.enableUnavailable':
    'לא ניתן להפעיל מודול מוסתר. יש לכבות תחילה את „מוסתר”; הוא נשאר כבוי עד להפעלתו בצעד נפרד.',
  'clinicModules.pending': 'שומר את השינוי…',
  'clinicModules.saved': 'השינוי נשמר. השרת אישר את המצב החדש (גרסה {revision}).',
  'clinicModules.savedListStale':
    'השינוי נשמר ואושר על ידי השרת (גרסה {revision}). לא ניתן היה לרענן את שאר הרשימה והיא עשויה שלא להיות עדכנית.',
  'clinicModules.stateChangedElsewhere':
    'מישהו אחר שינה מודול זה בזמן שקיבלת החלטה. לא בוצע שינוי על ידך; המצב המוצג הוא המצב הנוכחי בשרת. יש לבחור שוב אם עדיין נדרש שינוי.',

  'clinicModules.confirm.enableTitle': 'להפעיל את {name}?',
  'clinicModules.confirm.enableDescription':
    'המודול מתחיל לקבל בקשות נכנסות, להריץ פקודות ועבודות רקע ולבצע את הקריאות היוצאות שהוא מצהיר עליהן. הוא אינו מקבל גישה שאין לחשבון כבר.',
  'clinicModules.confirm.enable': 'הפעלה',
  'clinicModules.confirm.disableTitle': 'לכבות את {name}?',
  'clinicModules.confirm.disableDescription':
    'נתוני המודול השמורים נשארים קריאים ודבר אינו נמחק. בקשות נכנסות חדשות, פקודות, משימות רקע, קריאות בינה מלאכותית, הודעות וכל פעולה אחרת שהמודול מתחיל יידחו עד להפעלתו מחדש.',
  'clinicModules.confirm.disable': 'כיבוי',
  'clinicModules.confirm.hideTitle': 'להסתיר את {name}?',
  'clinicModules.confirm.hideDescription':
    'הסתרה גם מכבה את המודול באותו צעד. פריטי הניווט, הבלוקים בלוח הבקרה, תגי המטופל, המקורות, חלקי התיק ורשומות ציר הזמן שלו נעלמים מכל משטח רגיל.',
  'clinicModules.confirm.hideRetained':
    'נתוני המודול השמורים נשמרים. רשומות קליניות, הודעות למטופלים ורשומות ביקורת שהמרפאה כבר תיעדה נשארות בדיוק כפי שהן. רק מפתחים יכולים לראות אותו בקטלוג ולהציגו שוב לארגון.',
  'clinicModules.confirm.hide': 'הסתרה וכיבוי',
  'clinicModules.confirm.unhideTitle': 'להציג שוב את {name}?',
  'clinicModules.confirm.unhideDescription':
    'המודול חוזר למשטחים הרגילים אך נשאר כבוי. הפעלתו היא צעד נפרד, שנעשה לאחר מכן.',
  'clinicModules.confirm.unhide': 'הצגה מחדש',
  'clinicModules.confirm.cancel': 'להשאיר כפי שהוא',
  'clinicModules.confirm.retry': 'לנסות שוב',

  'clinicModules.reason.legend': 'סיבה',
  'clinicModules.reason.hint': 'נרשמת יחד עם השינוי ביומן הביקורת של המרפאה.',
  'clinicModules.reason.other': 'אחר',
  'clinicModules.reason.detail': 'פירוט הסיבה',
  'clinicModules.reason.rollout': 'הטמעה במרפאה זו',
  'clinicModules.reason.maintenance': 'תחזוקה',
  'clinicModules.reason.maintenanceDone': 'התחזוקה הסתיימה',
  'clinicModules.reason.configuration': 'התצורה אינה מלאה',
  'clinicModules.reason.notUsed': 'אינו בשימוש במרפאה זו',
  'clinicModules.reason.postponed': 'ההטמעה נדחתה',

  'clinicModules.error.concurrent':
    'מישהו אחר שינה מודול זה קודם. לא בוצע שינוי על ידך; המצב הנוכחי מוצג כעת.',
  'clinicModules.error.hiddenCannotEnable':
    'המודול מוסתר ולא ניתן להפעילו. דבר לא שונה; יש לכבות תחילה את „מוסתר”.',
  'clinicModules.error.forbidden': 'לחשבון זה אין עוד הרשאה לשנות מצב מודולים. דבר לא שונה.',
  'clinicModules.error.invalid': 'השרת דחה את השינוי כלא תקין. דבר לא שונה.',
  'clinicModules.error.notFound': 'מודול זה אינו זמין לארגון זה. דבר לא שונה.',
  'clinicModules.error.unavailable': 'לא ניתן להגיע לשרת. דבר לא שונה; יש לנסות שוב.',
  'clinicModules.error.malformed':
    'השרת ענה, אך לא ניתן היה לקרוא את תשובתו. יש לטעון מחדש את הרשימה כדי לראות אם השינוי הוחל.',
  'clinicModules.error.failed': 'לא ניתן היה לשמור את השינוי. דבר לא שונה.',
}
